import PropTypes from "prop-types"

import { cn } from "styles/utils"

// size - lg: collection page; sm: PDP product recommendation
const ProductDescription = ({
  as: Component = "p",
  productName,
  size = "lg",
}) => {
  return (
    <Component
      className={cn(
        "body-sm desktop:leading-tight mb-4 truncate font-medium",
        size === "lg" && "desktop:text-16"
      )}
      title={productName}
    >
      {productName}
    </Component>
  )
}

ProductDescription.propTypes = {
  as: PropTypes.elementType,
  productName: PropTypes.string,
  size: PropTypes.string,
}

export default ProductDescription
